import { render } from "./JobReviewView.vue?vue&type=template&id=cccfd960"
import script from "./JobReviewView.vue?vue&type=script&lang=js"
export * from "./JobReviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__